import type { RudderAnalytics } from "@rudderstack/analytics-js";

const useIdentify = (shouldCall: boolean) => {
  const identify = (analytics: RudderAnalytics, userId: string) => {
    if (!shouldCall) return;

    analytics?.identify(userId);
  };

  return identify;
};

export { useIdentify };
